import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import { reduxForm, change, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { FormField, Toolbar } from "admin-on-rest";
import { Box } from "rebass";
import { GET_LIST } from "admin-on-rest";
import isNil from "lodash.isnil";
import getDefaultValues from "../components/form/getDefaultValues";
import { ValuesForm, SearchMarketerChip } from "../components";
import { DivFormContainer } from "./styled";
import { RestClient } from "../restClient";

const validate = values => {
  const errors = {
    contact: {
      email: null,
      mobile: null
    }
  };
  if (!values.name) {
    errors.name = "Required";
  }

  if (!values.contact) {
    errors.contact["mobile"] = "Required";
    errors.contact.email = "Required";
  } else {
    if (!values.contact.mobile) {
      errors.contact["mobile"] = "Required";
    }
    if (!values.contact.email) {
      errors.contact.email = "Required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.contact.email)
    ) {
      errors.contact["email"] = "Invalid email address";
    }
  }

  return errors;
};

class AgencyForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      if (isNil(values.custom)) {
        //check if api_key is null
        values.custom = { api_key: "" };
      }
      this.props.save(values, redirect);
    });
  constructor(props) {
    super(props);
    const { record } = props;
    this.state = {
      usersRecord: []
    };
    if (record && record.users && record.users.length > 0) {
      this.getUsers(record.users);
    }
  }
  getUsers(users) {
    RestClient(GET_LIST, "users", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "first_name", order: "ASC" },
      filter: {}
    })
      .then(items => {
        if (items && items.data) {
          const res = items.data.filter(function(el) {
            return users.indexOf(el.id) >= 0;
          });
          // console.log(res);
          this.setState({
            usersRecord: res
          });
        }
      })
      .catch(e => {
        // resolve([]);
      });
  }

  onChangeUsers = Users => {
    const data = Users.map(item => {
      return item.id;
    });
    this.props.updateUsers(data);
  };
  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar
    } = this.props;

    return (
      <div>
        <form className="simple-form">
          <DivFormContainer>
            <Box px={[1, 2]}>
              {Children.map(
                children,
                input =>
                  input && (
                    <div
                      key={input.props.source}
                      className={`aor-input-${input.props.source}`}
                      style={input.props.style}
                    >
                      <FormField
                        input={input}
                        resource={resource}
                        record={record}
                        basePath={basePath}
                      />
                      {input.props.source === "name" && (
                        <Box w={[1]}>
                          <SearchMarketerChip
                            data={this.state.usersRecord}
                            nameUsers={record.users}
                            onChangeUser={this.onChangeUsers.bind(this)}
                          />
                        </Box>
                      )}
                    </div>
                  )
              )}
            </Box>
          </DivFormContainer>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
          <ValuesForm isDebug={false} formName={"record-form"} />
        </form>
      </div>
    );
  }
}

AgencyForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  translate: PropTypes.func
};

AgencyForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};
const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const users = selector(state, "users");
      return {
        initialValues: getDefaultValues(state, props),
        users
      };
    },
    {
      updateUsers: users => change("record-form", "users", users)
    }
  ),
  reduxForm({
    form: "record-form",
    validate,
    enableReinitialize: true
  })
);

export default enhance(AgencyForm);



// WEBPACK FOOTER //
// ./src/agency/AgencyForm.js